import { render } from "./DeleteProductModal.vue?vue&type=template&id=e6edd19e&scoped=true"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js"

import "./DeleteProductModal.vue?vue&type=style&index=0&id=e6edd19e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6edd19e"]])

export default __exports__